import React, {Component} from 'react'
import * as firebase from 'firebase'
import {browserHistory} from 'react-router'

const Jeyu = {
  Box: {
    background: '#333',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  }
}

export default class Add extends Component {
  constructor() {
    super();
    this.state = {
      title: '',
      slug: ''
    }
    this.handleChangeTitle = this.handleChangeTitle.bind(this)
    this.handleChangeSlug = this.handleChangeSlug.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleChangeTitle(event) {
    this.setState({
      title: event.target.value
    })
  }
  handleChangeSlug(event) {
    this.setState({
      slug: event.target.value
    })
  }
  handleSubmit(event) {
   firebase.database().ref('posts/').push({
     title: this.state.title,
     slug: this.state.slug
   })
   event.preventDefault()
  }

  componentDidMount() {
    var user = firebase.auth().currentUser
    if (user) {
      console.log('歡迎Admin')
    } else {
      browserHistory.push('/Login')
    }
    event.preventDefault()
  }
  render() {
    return(
     <div style={Jeyu.Box}>
      <form onSubmit={this.handleSubmit}>
       <div>
        <label>標題</label>
        <input type="text" value={this.state.title} onChange={this.handleChangeTitle} />
       </div>
       <div>
        <label>id</label>
        <input type="text" value={this.state.id} onChange={this.handleChangeID} />
       </div>
       <div>
        <label>連結</label>
        <input type="text" value={this.state.slug} onChange={this.handleChangeSlug} />
       </div>
       <input type="submit" value="go" />
      </form>
     </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Blog/Add.js